import { useRouter } from 'next/router'
import { useEffect, useRef } from 'react'

import { QueryKeyENUM } from '../atoms/Filters/ApplyFilters.model'
import type { ItemType } from './ApplyFilters.model'
import { Duration } from './DurationFilter/DurationFilter'

// URL задаёт применённые фильтры; Redux хранит подписи и изменения открытой формы.
export const useCatalogueFilterQuery = (
  programs: boolean | undefined,
  selectedFilters: Record<QueryKeyENUM, ItemType>,
  setFilters: (key: QueryKeyENUM, item: ItemType | null) => void,
) => {
  const router = useRouter()
  const selected = useRef(selectedFilters)
  selected.current = selectedFilters

  useEffect(() => {
    if (
      programs === undefined ||
      !router.isReady ||
      !/^\/(programs|events|map)\/?$/.test(router.asPath.split('?')[0])
    )
      return
    const keys = programs
      ? [
          QueryKeyENUM.teacherId,
          QueryKeyENUM.programType,
          QueryKeyENUM.programId,
          QueryKeyENUM.eduForm,
          QueryKeyENUM.adaptationProgram,
          QueryKeyENUM.programDurationInHours,
        ]
      : [QueryKeyENUM.adaptationProgram]
    keys.forEach((key) => {
      const raw = router.query[key]
      let value = Array.isArray(raw) ? raw[0] : raw
      if (key === QueryKeyENUM.programDurationInHours && value) {
        value =
          ({ '37-72': '37-71', '73+': '72+' } as Record<string, string>)[
            value
          ] || value
      }
      const previous = selected.current?.[key]
      const duration =
        key === QueryKeyENUM.programDurationInHours
          ? Duration.find((item) => item.id === value)
          : undefined
      if (
        value &&
        (duration ||
          (key === QueryKeyENUM.adaptationProgram
            ? value === 'true'
            : /^[1-9]\d*$/.test(value)))
      ) {
        const item = duration
          ? { ...duration, value: duration.id }
          : {
              value:
                key === QueryKeyENUM.adaptationProgram ? 'true' : Number(value),
              name:
                key === QueryKeyENUM.adaptationProgram
                  ? 'Для детей с ОВЗ'
                  : `№ ${value}`,
            }
        setFilters(key, String(previous?.value) === value ? previous : item)
      } else if (previous) setFilters(key, null)
    })
  }, [router.isReady, router.asPath, router.query, programs, setFilters])
}
